import { put, takeEvery, call, all, select } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'

// import product services
import { getUsers, putUser, deleteUser } from '../../services/users'

const getCurrentUser = state => state.user

export function* fetchUsers() {
  try {
    const user = yield select(getCurrentUser)
    const { data } = yield call(() => getUsers(user.token))
    yield put({
      type: actions.FETCH_USERS_SUCCESS,
      data,
    })
  } catch (error) {
    yield put({ type: actions.FETCH_USERS_ERROR, message: error.message })
  }
}

export function* setUser(xUser) {
  try {
    const user = yield select(getCurrentUser)

    // ajusta los json
    xUser.payload.datetimedatajson = JSON.parse(xUser.payload.datetimedatajson)
    xUser.payload.sysdatajson = JSON.parse(xUser.payload.sysdatajson)
    xUser.payload.extradatajson = JSON.parse(xUser.payload.extradatajson)
    xUser.payload.operdatajson = JSON.parse(xUser.payload.operdatajson)

    yield call(() => putUser(user.token, xUser.payload))
    notification.success({
      message: 'Grabado exitoso',
      description: 'Se han guardado exitósamente los cambios',
    })
    yield put({
      type: actions.FETCH_USERS,
    })
  } catch (error) {
    yield put({ type: actions.USER_ERROR, message: error.message })
  }
}

export function* delUSer(xUser) {
  try {
    const user = yield select(getCurrentUser)
    yield call(() => deleteUser(user.token, xUser.payload.uid))
    notification.success({
      message: 'Borrado exitoso',
      description: 'Se ha eliminado exitósamente el producto',
    })
    yield put({
      type: actions.FETCH_USERS,
    })
  } catch (error) {
    yield put({ type: actions.USER_ERROR, message: error.message })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_USERS, fetchUsers),
    takeEvery(actions.USER_SET, setUser),
    takeEvery(actions.USER_DEL, delUSer),
  ])
}
